import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminPeopleCreate: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Create>
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <TextInput name="email" source="email"  validate={[required()]} fullWidth />
                { (loading) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                }
                { (!loading) &&
                    <SelectInput
                        choices={ loadedCountries }
                        source="country"
                        optionValue="id"
                    />
                }

                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}